/* eslint-disable simple-import-sort/imports */
/* eslint-disable curly */
// This code is generated automatically. Do not modify it manually.
// The suppressions below are required to suppress false positive ESLint warnings.
//
// Generated: Mon, 27 Jul 2026 15:46:33 GMT
//
// noinspection RedundantIfStatementJS, JSUnusedGlobalSymbols, DuplicatedCode
//
import { FiatAccountType } from '@/types/fiatAccountType';

const valuesOfFiatAccountType: readonly string[] = [
  'ACH',
  'RTP',
  'SWIFT',
  'SEPA',
  'WIRE',
  'PIX',
  'COP',
  'SPEI',
  'CVU',
  'CRYPTO',
  'CNAPS',
  'CHATS',
  'FASTER_PAYMENTS',
  'IMPS',
  'INSTAPAY',
  'RTC',
  'PROMPTPAY',
  'BI_FAST',
  'GHIPSS',
  'PESALINK',
  'FAST',
  'EFT',
  'TEF',
  'NIP',
  'CCE',
  'IPP',
  'BOB_ACH',
  'MOBILE_WALLET',
  '',
];

export const isFiatAccountType = (value: unknown): value is FiatAccountType => {
  if (typeof value !== 'string') {
    return false;
  }
  return valuesOfFiatAccountType.includes(value);
};

export const isFiatAccountTypeOrNull = (value: unknown): value is FiatAccountType | null => {
  return value === null || isFiatAccountType(value);
};

export const isArrayOfFiatAccountType = (value: unknown): value is FiatAccountType[] => {
  return Array.isArray(value) && value.every(isFiatAccountType);
};

export const isArrayOfFiatAccountTypeOrNull = (
  value: unknown,
): value is FiatAccountType[] | null => {
  return value === null || isArrayOfFiatAccountType(value);
};
